import React from 'react';
import PropTypes from 'prop-types';

import Pin from './Pin.jsx';

import { locationsPropType, ticketsPropType } from '../propTypes.js';

function PinsAndPopups({ locations, selectedLocationId, tickets }) {
  return (
    <>
      {locations.map((location, i) => location.locationId && (
      <Pin
        key={location.locationId}
        hidden={selectedLocationId !== '' && selectedLocationId !== location.locationId}
        showPopup={selectedLocationId === location.locationId}
        text={tickets[i].location}
        x={location.xCoord}
        y={location.yCoord}
      />
      ))}
    </>
  );
}

PinsAndPopups.propTypes = {
  locations: locationsPropType.isRequired,
  selectedLocationId: PropTypes.string.isRequired,
  tickets: ticketsPropType.isRequired,
};

export default PinsAndPopups;
